import { Checkbox } from '@roger/ui-components';
import { useAgencyHasExternalEmr } from '../../hooks/useExternalEmrImport';

/** Shared copy for the exclude-pre-takeover manager filter. */
export const EXCLUDE_PRE_TAKEOVER_FILTER_LABEL =
  'Exclude items before patient take-over';

export interface ExcludePreTakeoverFilterCheckboxProps {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** Extra classes on the outer flex wrapper (layout per page). */
  className?: string;
}

/**
 * Checkbox shown only for dual Roger + External EMR agencies.
 *
 * Cut-off is each patient's confirmed Roger charts-from day
 * (`Episode.roger_charts_from`). Patients without a take-over stay visible.
 */
export function ExcludePreTakeoverFilterCheckbox({
  id,
  checked,
  onCheckedChange,
  className = 'flex h-8 items-center gap-2 self-end col-span-2 md:col-span-1',
}: ExcludePreTakeoverFilterCheckboxProps) {
  const show = useAgencyHasExternalEmr();
  if (!show) return null;

  return (
    <div className={className}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value: boolean) => {
          onCheckedChange(!!value);
        }}
        checkboxSize='sm'
      />
      <label
        htmlFor={id}
        className='text-xs text-muted-foreground cursor-pointer select-none whitespace-nowrap'
      >
        {EXCLUDE_PRE_TAKEOVER_FILTER_LABEL}
      </label>
    </div>
  );
}
